// extracted by mini-css-extract-plugin
export default {"tabs":"BasicTabs_tabs__3yH0x"};